module.exports = __webpack_public_path__ + "img/3.08f34f02.webp";